<template>
  <div>

    <div class="rounded mt-3 py-2 px-2 flex mb-3 justify-between">
      <div>
        <h1 class="mb-8 font-bold text-3xl">My Cart</h1>
      </div>
      <div>
        <inertia-link class="block bg-white rounded hover:shadow border border-gray-300 btn-standard py-2 px-3 text-base" type="button" :href="route('customer.shopping')" >Go back to shopping</inertia-link>
      </div>
    </div>


    <div v-if="restrictions.length" v-for="notice in restrictions" class="text-red-800 mx-auto bg-red-100 rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6">
      <div class="flex"> {{ notice.message}}</div>
      <div class="flex flex-col mt-2 border border-red-400 p-2 rounded bg-red-300 hover:bg-red-500 cursor-pointer items-center text-red-900 hover:text-white" v-if="notice.type === 'new_order_with_pending'"><inertia-link :href="route('my-orders')">See pending orders</inertia-link></div>
    </div>

<!--    <div v-if="dailyLimitMessageShow" class="mx-auto bg-red-100 rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6">-->
<!--      <div class="flex">-->
<!--        <div class="flex-shrink-0">-->
<!--          <svg class="h-5 w-5 text-red-300" fill="currentColor" viewBox="0 0 20 20">-->
<!--            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <div class="ml-3">-->
<!--          <h3 class="text-sm leading-5 font-medium text-red-800">-->
<!--            Dear Customer-->
<!--          </h3>-->
<!--          <div class="mt-2 text-sm leading-5 text-red-700">-->
<!--            <p>-->
<!--              {{ dailyLimitMessage }}-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="rounded-md bg-red-50 p-4" v-if="errorMessages.length > 0">
      <div class="flex">
        <div class="flex-shrink-0">
          <!-- Heroicon name: x-circle -->
          <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
          </svg>
        </div>
        <div class="ml-3">
          <h3 class="text-sm leading-5 font-medium text-red-800">
            Oops! Something went wrong.
          </h3>
          <div class="mt-2 text-sm leading-5 text-red-700">
            <ul class="list-disc pl-5">
              <li v-for="errMsg in errorMessages">
                {{ errMsg.message }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1">
      <div class="col-span-3 mb-4">
        <table class="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                  <th class="hidden lg:table-cell px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase"></th>
                  <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase">Item description</th>
                  <th class="hidden lg:table-cell bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase">Qty</th>
                  <th class="hidden lg:table-cell bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase">Unit</th>
                  <th v-if="showItemRate" class="hidden lg:table-cell px-6 py-3 bg-gray-50 text-right text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Rate</th>
                  <th v-if="showItemTotal" class="hidden lg:table-cell px-6 py-3 bg-gray-50 text-right text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Total</th>
                  <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in form.items" class="bg-white border-b border-gray-200" v-if="item">
                  <td class="hidden lg:block px-6 py-4 text-sm leading-5 font-medium text-gray-900">
                    <img :src="item.product.image" class="h-12"/>
                  </td>
                  <td class="px-6 py-4 text-sm leading-5 font-medium text-gray-900 w-auto">
                    <div>{{ item.product.description }}</div>
                    <div>
                      <span>{{ item.product.item_code }}</span> <span class="text-sm text-gray-400">@{{ shoppingLocations[item.product.location] }}</span>
                    </div>
                    <div class="lg:hidden flex">
                      <div class="w-full flex flex-col py-2">
                        <div class="flex">
                          <button @click="decQty(item)"
                                  class="-mr-px relative inline-flex items-center px-2.5 py-1 border border-gray-300 text-sm leading-4 font-medium rounded-l-md text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150">
                            -
                          </button>
                          <div class="relative focus-within:z-10 flex items-center border border-gray-300">
                            <input type="number" ref="qty" v-model.number="item.qty" id="qt" @change="() => sync(item)"
                                   class="h-8 border-0 focus:outline-none number-no-spin mx-0 text-center w-12 text-xs rounded-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                   placeholder="qty"/>
                            <div class="text-xs px-1">{{ item.unit }}</div>
                          </div>
                          <button @click="incQty(item)"
                                  class="-ml-px relative inline-flex items-center px-2.5 py-1 border border-gray-300 text-xs leading-4 font-medium rounded-r-md text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150">
                            +
                          </button>
                        </div>
                        <div v-if="showItemRate" class="text-xs">
                          <span class="text-gray-400">Rate MVR {{ itemRatePrice(item) }}</span>
                        </div>
                        <div v-if="showItemTotal" class="text-sm">
                          <span class="text-gray-600">MVR {{ itemTotalPrice(item) }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="!isItemAvailable(item)" class="text-red-500 text-xs">
                      <span v-if="item.product.available">Not available for this unit</span>
                      <span v-else>Out of stock</span>
                    </div>

                  </td>
                  <td class="hidden lg:table-cell whitespace-nowrap text-sm font-medium text-gray-900 text-left w-2">
                    <div>
                      <div class="flex mx-1">
                        <button @click="decQty(item)"
                                class="-mr-px relative inline-flex items-center px-2.5 py-1 border border-gray-300 text-sm leading-4 font-medium rounded-l-md text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150">
                          -
                        </button>
                        <div class="relative focus-within:z-10">
                          <input type="number" ref="qty" v-model.number="item.qty" id="qt" @change="() => sync(item)"
                                 class="form-input number-no-spin mx-0 text-center w-12 text-xs rounded-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                 placeholder="qty"/>
                        </div>
                        <button @click="incQty(item)"
                                class="-ml-px relative inline-flex items-center px-2.5 py-1 border border-gray-300 text-xs leading-4 font-medium rounded-r-md text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150">
                          +
                        </button>
                      </div>
                    </div>
                  </td>
                  <td class="hidden lg:table-cell whitespace-nowrap text-sm leading-5 font-medium text-gray-900 w-2 text-left">
                    <div>{{ item.unit }}</div>
                  </td>
                <td v-if="showItemRate" class="hidden lg:table-cell px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 text-right">
                  <div>{{ itemRatePrice(item) }}</div>
                </td>
                <td v-if="showItemTotal" class="hidden lg:table-cell px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 text-right">
                  <div>{{ itemTotalPrice(item) }}</div>
                </td>
                  <td class="whitespace-nowrap text-sm font-medium text-gray-900 w-1">
                    <button class="text-red-400" @click="removeItem(item)">
                      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                    </button>
                  </td>
              </tr>
            </tbody>
        </table>
        <div v-if="canPlaceOrder && showNettTotal" class="bg-gray-200 px-3 py-2 text-right pr-16">
          <div>
           Total MVR {{ totalPriceOfAllItems }}
          </div>
        </div>
      </div>

      <div class="mt-2"  >
        <div class="bg-gray-200 rounded p-4">
          <p class="pb-4 text-sm">Please review the items in the cart before placing your order.</p>

          <div class="grid gap-3 grid-cols-1 md:grid-cols-2">
            <div class="flex flex-col">
              <label class="block text-sm font-medium leading-5 text-gray-700 md:mr-3">
                Select your account
              </label>
              <div class="flex rounded-md shadow-sm">
                <select id="shop" v-model="form.account_id" class="block form-select w-full transition duration-150 ease-in-out sm:text-sm">
                  <option v-for="account in accounts" :value="account.id">{{ `${account.name} (TIN: ${account.tin_number})` }}</option>
                </select>
              </div>
            </div>
            <div class="block mb-3" v-if="canPlaceOrder">
              <div class="block">
                <label class="block text-sm font-medium leading-5 text-gray-700">
                  PO Reference (optional)
                </label>
                <div class="mt-1 flex rounded-md shadow-sm">
                  <input v-model="form.customer_reference" class="form-input flex-1 block w-full rounded transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
                </div>
              </div>
            </div>

            <div class="mt-4 bg-white shadow rounded-lg text-gray-500" v-if="canPlaceOrder">
              <div class="border-b border-gray-200 px-6 py-3 sm:px-6 text-xs uppercase leading-4 font-medium">
                Goods Collection
              </div>
              <div class="border-t border-gray-100" />

              <div class="px-4 py-5 sm:p-6">
                <div v-if="!enableDelivery" class="bg-orange-50 p-4 mb-4 text-orange-800 border-orange-100">
                  Delivery service is temporarily not available.
                </div>

                <div class="block mb-3">
                  <div class="block">
                    <label class="block font-medium leading-5">
                      Contact Number
                    </label>
                    <div class="mt-1 flex">
                      <text-input v-model="form.contact_number" class="number-no-spin" type="number" :errors="page_errors.contact_number" />
                    </div>
                  </div>
                </div>



                <fieldset class="mt-6">
                  <legend class="text-base font-medium text-gray-900">
                    Choose collection option
                  </legend>
                  <div class="mt-4">
                    <div class="flex items-center">

                      <label class="ml-3 flex items-center">
                        <input type="radio" v-model="collection_option" value="self_collect" class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out" />
                        <span class="ml-2 py-2 block text-sm leading-5 font-medium text-gray-700">Self collect from BHM store/warehouse locations</span>
                      </label>
                    </div>

<!--                    <div class="block mb-3" v-if="form.customer_to_collect">-->
<!--                      <div class="block pl-7">-->
<!--                        <label class="block text-xs font-medium leading-5 text-gray-500">-->
<!--                          Handover contact mobile-->
<!--                        </label>-->
<!--                        <div class="mt-1 flex">-->
<!--                          <text-input v-model="form.delivery_contact_number" class="number-no-spin" type="number" :errors="page_errors.contact_number" />-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->

                    <div class="mt-4 flex items-center" v-if="enableDelivery">

                      <label  class="ml-3 flex items-center">
                        <input type="radio" v-model="collection_option" value='delivery' class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out" />
                        <div class="text-sm leading-5 font-medium text-gray-700 inline-block py-2 ml-2" v-if="selectedAccount && selectedAccount.personal_account == false">Deliver to
                          <span v-if="deliveryLocationType === 'vessel_location'">a boat</span>
                          <span v-if="deliveryLocationType === 'address'">business location</span>
                        </div>
                        <div class="text-sm leading-5 font-medium text-gray-700 inline-block py-2 ml-2" v-else>Deliver to a
                          <span v-if="deliveryLocationType === 'vessel_location'">boat</span>
                          <span v-if="deliveryLocationType === 'address'">your address</span>
                        </div>

                      </label>
                    </div>

                  </div>
                </fieldset>

                <div v-if="form.customer_to_collect && enableDelivery" class="bg-green-100 text-green-500 border-green-300 p-4 mb-4 rounded">
                  Delivery service is available for this order.
                </div>

                <div v-if="collection_option == 'delivery' && enableDelivery">

                  <div v-if="deliveryLocationType === 'vessel_location'">
                    <label  class="ml-3" >
                      <span class="block text-sm leading-5 font-medium text-gray-700">Choose boat</span>
                      <v-select v-model="form.boat" label="name" :options="boatList" aria-required="true" required>

                        <template v-slot:option="option">
                          {{ option.name }} <span v-if="option.alt_name" class="text-gray-400 ml-2 text-sm">{{ option.alt_name }}</span>
                        </template>

                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching">
                            No matching boat with name <em>{{ search }}</em>.
                          </template>
                          <em style="opacity: 0.5;" v-else>Select or type to search...</em>
                        </template>

                        <template #search="{attributes, events}">
                          <input
                            class="vs__search"
                            :required="!form.boat"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-select>
                    </label>

                    <text-input v-if="collection_option == 'delivery' && form.boat && form.boat.id === 'other'" class="mt-3 text-sm" v-model="form.other_boat_name" :errors="page_errors.other_boat_name"  required label="Boat Name" />

                    <label  class="ml-3">
                      <span class="block text-sm leading-5 font-medium text-gray-700">Boat location</span>
                      <v-select v-model="form.boat_location" :options="addressConfig.vessel_locations.island" />
                    </label>
                  </div>


<!--                  <div class="max-w-full mb-5 mt-2" v-if="selectedAccount">-->
<!--                    <div v-if="addresses.length" v-for="address in addresses" class="flex items-center mb-2 ml-8">-->
<!--                      <input :id="`address-${address.id}`" v-model="form.address" name="address" :value="address.id" type="radio" class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out">-->
<!--                      <label :for="`address-${address.id}`" class="ml-3 w-full flex">-->
<!--                        <span v-if="address.location === 'island'" class="block text-sm leading-5 font-medium">{{ address.vessel_details }}, {{ address.vessel_location }}, {{ address.contact_number }}</span>-->
<!--                        <span v-else class="block text-sm leading-5 font-medium">{{ address.location.charAt(0).toUpperCase() + address.location.slice(1) }}, {{ address.address }}, {{ address.contact_number }}</span>-->

<!--                        <button class="text-red-600 ml-auto" type="button" @click="confirmAddressRemoval(address)">-->
<!--                          <icon name="trash" class="w-4 h-4 fill-current" />-->
<!--                        </button>-->
<!--                      </label>-->
<!--                    </div>-->

<!--                    <div v-if="page_errors.address_id" class="form-error text-xs">{{ page_errors.address_id[0] }}</div>-->

<!--                    <div v-if="addresses.length === 0" class="text-sm font-medium text-gray-500 mt-2">No address added yet.</div>-->
<!--                  </div>-->

<!--                  <button type="button" class="btn-primary px-2.5 py-1.5" @click="openAddressModal = true">Add new delivery location</button>-->
                </div>


                <div class="block mb-3 mt-3">
                  <div class="block">
                    <label class="block text-sm font-medium leading-5 text-gray-700">
                      Remarks
                    </label>
                    <div class="mt-1 flex rounded-md shadow-sm">
                      <textarea v-model="form.remarks" :class="{'error': page_errors.remarks}" class="form-input flex-1 block w-full rounded transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="rounded-md bg-red-50 p-4 text-red-700 py-3 mt-2" v-if="errorMessages.length">
            Sorry, we are not able to proceed. Please check the error message above.
          </div>

          <loading-button v-if="canPlaceOrder" class="btn-primary uppercase py-3 ml-2 px-3 mt-4" type="button" :loading="sending" @click="checkout" >Place Order Now</loading-button>
        </div>
      </div>
    </div>


<!--    <div class="flex justify-center items-center" v-if="totalApprovedCustomerAccounts === 0">-->

<!--      <div class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6">-->
<!--        <div class="sm:flex sm:items-start">-->
<!--          <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-orange-100 sm:mx-0 sm:h-10 sm:w-10">-->
<!--            <svg class="h-6 w-6 text-orange-400" stroke="currentColor" fill="none" viewBox="0 0 24 24">-->
<!--              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>-->
<!--            </svg>-->
<!--          </div>-->
<!--          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">-->
<!--            <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">-->
<!--              There are no approved shops at this time, please check this page later.-->
<!--            </h3>-->
<!--            <div class="mt-2">-->
<!--              <p class="text-sm leading-5 text-gray-500">-->
<!--                If you have not yet submitted your shop/business, please click the button below to submit.-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->


<!--        <div class="mt-5 sm:mt-4 flex">-->
<!--          <span class="flex w-full rounded-md shadow-sm justify-end">-->
<!--            <inertia-link :href="route('my-shops')" class="btn-primary">Submit</inertia-link>-->
<!--          </span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="rounded mt-3 py-2 px-2 flex mb-3 justify-between">
      <div></div>
      <div>
        <inertia-link class="block bg-white rounded hover:shadow border border-gray-300 btn-standard py-2 px-3 text-base" type="button" :href="route('customer.shopping')" >Go back to shopping</inertia-link>
      </div>
    </div>

    <!-- address add modal -->
<!--    <modal v-if="!form.customer_to_collect" :show="openAddressModal" @closeModal="openAddressModal = false">-->
<!--      <address-form v-if="canPlaceOrder" :url="route('ajax.my-address.store', form.account_id)" :config="addressConfig" :account-id="form.account_id" :location="location"  @input="appendAddress" @close-modal="openAddressModal = false" />-->
<!--    </modal>-->

<!--    &lt;!&ndash; address removal modal &ndash;&gt;-->
<!--    <remove-address v-model="removingAddress"-->
<!--                    :open="openAddressRemovalConfirmation"-->
<!--                    :url="removingAddress.id ? route('ajax.my-address.delete', removingAddress.id) : null"-->
<!--                    @close-modal="openAddressRemovalConfirmation = false"-->
<!--                    @removed="removeAddress"></remove-address>-->

    <portal to="quickActions" >
      <div class="flex mx-3 items-center">
        <div class="hidden lg:block">
          <div class="flex flex-col md:flex-row md:items-center">
            <label class="block text-sm font-medium leading-5 text-gray-700 md:mr-3">
              Shopping Location
            </label>
            <div class="flex rounded-md shadow-sm">
              <select v-model="shopping_location" class="block form-select w-full transition duration-150 ease-in-out sm:text-sm">
                <option v-for="(shopLocation, slkey) in shoppingLocations" :value="slkey">{{ shopLocation }}</option>
              </select>
            </div>
          </div>
        </div>

      </div>
    </portal>

  </div>
</template>


<script>
  import Layout from '@/Shared/Customers/Layout'
  import store from './store'
  import LoadingButton from '@/Shared/LoadingButton'
  // import Modal from '@/Shared/Modal'
  // import AddressForm from '@/Pages/Customers/MyOrders/AddressForm'
  // import RemoveAddress from '@/Pages/Customers/MyOrders/RemoveAddress'
  import TextInput from '@/Shared/TextInput'

  store.setCustomerMode()

  function calculateItemPrice(item)
  {
     const rate = getItemRate(item)
     return parseFloat(rate * item.qty).toFixed(2);
  }

  function getItemRate(item) {
    return parseFloat(item.product.units[item.unit].price).toFixed(2)
  }

  function calculateTotalPriceOfAllItems(items)
  {
    let total = 0
    items.forEach(item => {
      total = (parseFloat(total) + parseFloat(calculateItemPrice(item))).toFixed(2)
    })
    return total
  }

  function isItemAvailableByUnit(item) {
    return item.product.units[item.unit].available >= item.qty
  }

  export default {
    name: 'CartReview',
    // components: {LoadingButton, Modal, AddressForm, RemoveAddress, TextInput},
    components: {LoadingButton, TextInput},
    layout: Layout,

    props: {

      shoppingLocations: {
        type: Object
      },
      showItemRate: {
        type: Boolean
      },
      showItemTotal: {
        type: Boolean
      },
      showNettTotal: {
        type: Boolean
      },
      accounts: {
        type: Array,
      },
      addressConfig: Object,
      // isOpenForOrdering: Boolean,
      canPlaceOrder: Boolean,
      contactNumber: String,
      deliveryEnabled: Boolean,
      deliverySettings: Object,
      dailyLimitEnabled: Boolean,
      selectedAccountId: Number,
      // dailyLimitMessageShow: Boolean,
      // dailyLimitMessage: String,
      // totalApprovedCustomerAccounts: Number,
      boatList: Array,
      errors: Object,
      restrictions: Array,
      // noAccountError: Boolean,
      // noAccountErrorMessage: String,
      // pendingOrderButtonShow: Boolean,
    },

    data() {
      return {
        shopping_location: null,
        form: store.form,
        collection_option: 'self_collect',
        openAddressModal: false,
        openAddressRemovalConfirmation: false,
        sending: false,
        // addresses: [],
        selectedAccount: null,
        removingAddress: {},
        errorMessages: [],
        page_errors: this.errors
      }
    },

    mounted() {
      // set default shopping location
      this.shopping_location = localStorage.getItem('my.defaultShoppingLocation') || this.addressConfig.shoppingDefaultLocation

      this.errorMessages = []
      store.setHttpClient(this.$http)
      store.reloadCart(this.shopping_location)
      if(this.form.customer_to_collect) {
        this.collection_option = 'self_collect'
      } else {
        this.collection_option = 'delivery'
      }

      store.form.account_id = this.selectedAccountId;

      this.setSelectedAccount(store.form.account_id)
      store.syncToLocalStorage()

    },

    watch: {
      'shopping_location': function(val) {
        localStorage.setItem('my.defaultShoppingLocation', val)
        store.reloadCart(this.shopping_location)
      },

      'collection_option': function(val) {
        if(val == 'self_collect') {
          this.form.customer_to_collect = true;
        } else {
          this.form.customer_to_collect = false;
        }
      },
      'form.account_id': {
        handler: function(val){
          if (val) {
            this.$inertia.visit(this.route('customer.cart', {ca: val}));
          }
        },
        immediate: false
      },
      // 'form.address': function (val) {
      //   if (val) {
      //     let address = this.addresses.find(itm => itm.id === val)
      //     if(address.remarks) {
      //       this.form.remarks = address.remarks
      //     }
      //   }
      // },
    },

    computed: {
      totalPriceRowColspan() {
        let totalCols = 6;
        if(!this.showItemRate) {
          totalCols--
        }
        if(!this.showItemTotal) {
          totalCols--
        }
        return totalCols
      },

      totalPriceOfAllItems() {
        return calculateTotalPriceOfAllItems(this.form.items)
      },

      enableDelivery() {
        if(this.deliveryEnabled) {
          if(this.location && this.deliverySettings[this.location]) {
            return this.deliverySettings[this.location].enable == true;
          }
        }
        return false;
      },

      deliveryLocationType() {
        if(this.selectedAccount) {
          return this.selectedAccount.delivery_location;
        }
        return null;
      },

      location() {
        if (this.accounts.length > 0 && this.form.account_id) {
          let customerAccount = this.accounts.find(itm => itm.id === this.form.account_id)

          return customerAccount.location;
        }

        return null;
      },
    },

    methods: {
      checkout() {
        // store.syncToLocalStorage()
        this.errorMessages = []

        this.sending = true

        // var data = new FormData();
        // data.append('customer_account_id', this.form.account.id)
        let data = {}
        data.items = this.form.items.map(item => {
          return {
            item_code : item.product.item_code,
            wcode : item.product.wcode,
            qty: item.qty,
            unit: item.unit
          }
        })
        data.location = this.shopping_location
        data.account_id = this.form.account_id
        // data.address_id = this.form.address
        data.remarks = this.form.remarks
        data.customer_reference = this.form.customer_reference
        data.contact_number = this.form.contact_number

        data.collection_option = this.collection_option
        if(this.collection_option === 'delivery') {
          if(this.deliveryLocationType === 'vessel_location') {
            data.boat = this.form.boat
            data.boat_location = this.form.boat_location
            if(data.boat.id === 'other') {
              data.other_boat_name = this.form.other_boat_name
            }
          }

          data.delivery_location = this.selectedAccount.delivery_location

        }

        this.$http.post(this.route('customer.cart.order'), data)
          .then(
            (response) => {
              store.resetForm()
                window.location = this.route('my-orders.show', response.data.orderId)
            }
          ).catch(error => {

            if(error.response.status === 422) {
              if(error.response.data) {
                this.page_errors = error.response.data.errors;
              }

            }

            if(error.response.status === 406) {
              if(error.response.data.type === 'error') {
                this.errorMessages.push({
                  message: error.response.data.message
                })
              }

              if(error.response.data.type === 'inventory') {
                // inventory items out of stock
                store.reloadCart(this.shopping_location)
                this.errorMessages.push({
                  message: error.response.data.message || 'Sorry, some items are no longer available. Please review the items in the cart again.'
                })
              }
            }
        }).finally(() => {
          this.sending = false
        });
      },

      setSelectedAccount(accountId) {
        let account = this.accounts.find(item => {
          return item.id == accountId;
        })

        if(account) {
          this.selectedAccount = account
          this.form.customer_to_collect = true
          this.collection_option = 'self_collect'
        } else {
          this.setDefaultCustomerAccount()
        }
      },

      setDefaultCustomerAccount() {
        if(this.accounts.length) {
          let account = this.accounts[0]
          this.form.account_id = account.id
          this.setSelectedAccount(account.id)
        }
      },

      // appendAddress(address) {
      //   this.addresses.push(address)
      //   this.openAddressModal = false
      //
      //   this.form.address = address.id
      // },
      //
      // removeAddress(address) {
      //   let index =  this.addresses.indexOf(address)
      //   this.addresses.splice(index, 1)
      //   this.removingAddress = {}
      //   this.openAddressRemovalConfirmation = false
      // },

      itemTotalPrice(item) {
        return calculateItemPrice(item)
      },

      itemRatePrice(item) {
        return getItemRate(item)
      },

      isItemAvailable(item) {
        return isItemAvailableByUnit(item)
      },

      sync(item) {
        store.updateQty(item)
        this.form = store.form
      },

      incQty(item) {
        this.sync({
          unit: item.unit,
          item_code: item.product.item_code,
          product: item.product,
          qty: item.qty + 1
        })
      },

      decQty(item) {
        if(item.qty > 1) {

          this.sync({
            unit: item.unit,
            item_code: item.product.item_code,
            product: item.product,
            qty: item.qty - 1
          })
        }
      },

      removeItem(item) {
        item.qty = 0
        this.sync(item)
      }
    }

  }
</script>
